import { markUiObject as __markUi } from '@/i18n/display'
// 2026-10-18：置顶筛选独立维护三语文案与布尔协议，不改并行生成的界面词典。
const labels = {
  zh: __markUi({label:'置顶筛选', options:['全部','已置顶','未置顶'], failed:'课程加载失败，请重试', retry:'重试'}, {"label":"置顶筛选"}),
  en: {label:'Pinned filter', options:['All','Pinned','Not pinned'], failed:'Courses could not load. Please retry.', retry:'Retry'},
  ug: {label:'ئۈستىگە قويۇش', options:['ھەممىسى','ئۈستىگە قويۇلغان','ئۈستىگە قويۇلمىغان'], failed:'دەرسلەر يۈكلەنمىدى، قايتا سىناڭ', retry:'قايتا سىناش'}
}
export function pinnedFilterLabels(language:unknown) {return labels[language==='en'?'en':language==='ug'?'ug':'zh']}
export function pinnedFilterValue(value:unknown):boolean|null {return value==='true'?true:value==='false'?false:null}
